import { Controller } from 'stimulus'
import { measure, mutate } from '~/common/helpers/layout_batch'

export default class extends Controller {
  static targets = ['readMoreButton', 'truncatedContent']
  static values = { truncationMode: String }

  connect() {
    if (this.truncationModeValue !== 'line') return

    this.lastClamped = undefined
    // The ResizeObserver delivers an initial observation as soon as it starts observing, so it
    // covers both the first measurement and the case where the element starts at 0×0 (e.g. inside
    // a hidden tab) and gets real dimensions later when its container becomes visible.
    this.resizeObserver = new ResizeObserver(() => this.adjustReadMoreButton())
    this.resizeObserver.observe(this.truncatedContentTarget)
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }

  // Measuring and then toggling the button dirties layout for every *other* instance on the page —
  // a grid of cards each doing read-then-write costs one full layout per card, and the write can
  // resize the observed element and re-fire the ResizeObserver. Going through layout_batch drains
  // every instance's read before any instance's write, so the page lays out once.
  adjustReadMoreButton() {
    if (this.truncationModeValue !== 'line') return

    measure(() => {
      if (!this.element.isConnected) return

      const { scrollHeight, clientHeight } = this.truncatedContentTarget
      // Not rendered yet — everything measures 0 and we'd wrongly conclude "not clamped". The
      // ResizeObserver calls us back once the element has real dimensions.
      if (clientHeight === 0) return

      const clamped = scrollHeight > clientHeight
      // Writing the class it already has would dirty layout and re-fire the ResizeObserver for
      // no reason, which is how this turns into a per-frame loop.
      if (clamped === this.lastClamped) return
      this.lastClamped = clamped

      mutate(() =>
        this.readMoreButtonTarget.classList.toggle('hidden', !clamped)
      )
    })
  }
}
